import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { InstallationFeaturesStore, WallboxDevicesWithMatchingBoilerSerial } from '@store';
import {
  Feature,
  FeaturePropertyKey,
  FeatureNames,
  IsStringValueProperty,
} from '@vi-iot/client/index';
import { Observable } from 'rxjs';
import { InstallationDetailsHeaderHelper } from '../installation-details-header.helper';
import { DevicesService } from 'src/app/@store/devices/devices.service';

@Component({
  selector: 'app-obng-wallbox-tile',
  templateUrl: './obng-wallbox-tile.component.html',
  styleUrl: './obng-wallbox-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ObngWallboxTileComponent implements OnInit {
  @Input({ required: true }) device: WallboxDevicesWithMatchingBoilerSerial;
  @Input({ required: true }) gatewaySerial: string;

  readonly imagePath = InstallationDetailsHeaderHelper.ImagePath;
  readonly FeaturePropertyKey = FeaturePropertyKey;

  deviceName$: Observable<string>;
  alternativeName$: Observable<string>;
  deviceModel$: Observable<Feature<IsStringValueProperty, never>>;

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private devicesService: DevicesService
  ) {}

  ngOnInit(): void {
    this.deviceName$ = this.devicesService.getOBNGWallboxDeviceName(this.device);
    this.deviceModel$ = this.installationFeaturesStore.selectInstallationDeviceFeature<
      IsStringValueProperty,
      never
    >(FeatureNames.deviceThirdpartyModel, this.device.id, this.gatewaySerial);
  }
}
